import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { SchoolTabs } from '../Tabs';

const coursesPropertyTypes = {
  profile: PropTypes.shape({
    coursesConnection: PropTypes.shape({
      edges: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
    }).isRequired,
  }).isRequired,
  children: PropTypes.node.isRequired,
};

type CoursesProperties = InferProps<typeof coursesPropertyTypes>;

const Courses = ({
  children,
  profile,
}: CoursesProperties) => (
  <>
    <SchoolTabs profile={profile} />
    {children}
  </>
);

Courses.propTypes = coursesPropertyTypes;

export default Courses;
